import { getSessionState } from "src/pageDefinitions/session";

export const isB2BPatient = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return (
    getSessionState("browser").isB2BPatientInternalOnly ||
    searchParams.get("isB2B") === "true"
  );
};
